module.exports = __webpack_public_path__ + "img/Draumkvedet_Dante-og-Vergil.54875853.jpg";